<template>
  <div class="container">
    <div
      class="show-imgs-container"
      @mouseover="isIn = true"
      @mouseout="isIn = false"
      id="anchor0"
    >
      <el-carousel
        :interval="cutTime"
        arrow="always"
        :autoplay="autoplay"
        trigger="click"
        :indicator-position="autoplay ? '' : 'none'"
        ref="carousel"
        @mouseenter.native="delHandleMouseEnter"
        @change="handleChange"
      >
        <el-carousel-item v-for="(item, index) in videos" :key="index">
          <video
            :ref="'videoPlayer' + index"
            :controls="isIn"
            muted
            autoplay
            loop
            aria-controls="false"
            class="video-player vjs-custom-skin"
          >
            <source :src="item.src" type="video/mp4" />
            您的浏览器不支持Video标签。
          </video>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="vedio_wrap1" v-if="index === 0">
      <div>
        <span class="title1">万物互联</span>&nbsp;&nbsp;&nbsp;&nbsp;
        <span class="title2">让设备告诉你</span>
      </div>
      <div class="txt">
        设备全寿命、状态评估、态势感知、实物ID
      </div>
      <div class="btn" @click="gotoInfor1">
        了解详情 >
      </div>
    </div>
    <div class="vedio_wrap1" v-if="index === 1">
      <div>
        <span class="title1">AI</span>&nbsp;&nbsp;&nbsp;&nbsp;
        <span class="title2">让机器人告诉你</span>
      </div>
      <div class="txt">
        智能巡检机器人、巡检电车、5G巡视识别摄像头
      </div>
      <div class="btn" @click="gotoInfor2">
        了解详情 >
      </div>
    </div>
    <div class="vedio_wrap1" v-if="index === 2">
      <div>
        <span class="title1">大数据挖掘</span>&nbsp;&nbsp;&nbsp;&nbsp;
        <span class="title2">让数据告诉你</span>
      </div>
      <div class="txt">
        数据中台云服务、线损分析、负荷预测、健康白皮书
      </div>
      <div class="btn" @click="gotoInfor">
        了解详情 >
      </div>
    </div>
    <div class="header">
      <img src="../assets/logo.png" alt="" />
      <div class="textGroup">
        <div class="text text1" @click="goAnchor('#anchor0')">首页</div>
        <div class="text text1" @click="goAnchor('#anchor1')">产品中心</div>
        <div class="text text1" @click="goAnchor('#anchor2')">成功案例</div>
        <div class="text text2" @click="goAnchor('#anchor3')">关于我们</div>
      </div>
    </div>
    <div class="product" id="anchor1">
      <div>
        <div class="product_title">产品中心</div>
        <div class="product_miniTitle">Products Center</div>
      </div>
      <div>
        <div class="proClass">
          <div class="pro1">
            <img src="../assets/p1.png" alt="" class="imgIcon" />
            <p class="proTitle">信息化</p>
            <p class="proText">Informatization</p>
            <p class="intro" @click="gotoInfor">
              <span class="el-icon-right"></span>
            </p>
          </div>
          <div class="pro2">
            <img src="../assets/p2.png" alt="" class="imgIcon" />
            <div class="proTitle">物联网</div>
            <p class="proText">Internet of Thin</p>
            <p class="intro" @click="gotoInfor1">
              <span class="el-icon-right"></span>
            </p>
          </div>
          <div class="pro3">
            <img src="../assets/p3.png" alt="" class="imgIcon" />
            <div class="proTitle">智能AI</div>
            <p class="proText">Intelligent AI</p>
            <p class="intro" @click="gotoInfor2">
              <span class="el-icon-right"></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="case" id="anchor2">
      <div>
        <div class="case_title">成功案例</div>
        <div class="case_miniTitle">Successful Cases</div>
      </div>
      <div class="one">
        <img src="../assets/pic1.png" alt="" class="left" />
        <div class="right">
          <div class="title">基于RFID的接地线管理系统</div>
          <div class="info">
            基于物联网的变电站挂接地线管理装置的研发成果，由国网上海市电力公司市北供电公司于
            2021年2月在钱湾站内进行了安装应用试验
          </div>
          <div class="arrow" @click="gotoMoreInfor">查看更多 →</div>
        </div>
      </div>
      <div class="one">
        <img src="../assets/pic2.png" alt="" class="left" />
        <div class="right">
          <div class="title">变电站音频指纹分析</div>
          <div class="info">
            音频处理平台在变电站巡检、远程集中监听等方面具有非常广阔的应用前景。本项目研究开
            发的音频处理平台可用于变电站运行状态诊断，通过音频文件提取有用的数据和信息。
          </div>
          <div class="arrow" @click="gotoMoreInfor1">查看更多 →</div>
        </div>
      </div>
      <div class="one">
        <img src="../assets/pic3.png" alt="" class="left" />
        <div class="right">
          <div class="title">履带式巡检机器人</div>
          <div class="info">
            2020年3月份-6月份在上海市市南配电站完成地面引导线铺设和一台地面式运维巡检机器人
            的部署任务，并开展了为期3个月的性能调试、功能验证及优化改进工作。
          </div>
          <div class="arrow" @click="gotoMoreInfor2">查看更多 →</div>
        </div>
      </div>
      <div class="btn_more" @click="gotoSuccess">
        更多案例 <span class="el-icon-right"></span>
      </div>
    </div>
    <div class="company" id="anchor3">
      <div>
        <div class="company_title">一站式管家服务</div>
        <div class="company_miniTitle">One-stop butler service</div>
      </div>
      <div>
        <div class="big">
          <div class="content">
            <img src="../assets/img4.png" alt="" />
            <!-- <img src="../assets/img1.png" alt=""> -->
            <div class="right_txt">
              <p class="title">医疗健康大数据中心</p>
              <p class="txt">
                建设医疗体检大数据中台。接入医疗、体检、随访等数据，对数据进行规范化处理；形成职工健康白皮书。结合权威医学数据与医疗专家意见，体检指标异常与风险预测，对已取得的历史数据进行建模与大数据分析；建设健康商城服务。结合行业特色，为用户提供更加优质的养老、健身、保健、保险等网络服务支持。
              </p>
            </div>
          </div>
        </div>
        <div class="small">
          <div class="content">
            <img src="../assets/img2.png" alt="" />
            <div class="right_txt">
              <p class="title">区域型综合能源互联网</p>
              <p class="txt">
                三联供、区域储能等分布式能源建设；区域内能源互联互通设计；区域内多能源组合优化调度分析；分时段能源供应及设备启停策略分析。
              </p>
            </div>
          </div>
          <div class="content">
            <img src="../assets/img3.png" alt="" />
            <div class="right_txt">
              <p class="title">楼宇节能与绿色电力</p>
              <p class="txt">
                为楼宇或企业提供绿色电力政策指导和申购服务；为园区或企业提供基于物联网的智能监控，电能质量治理；为园区或企业提供线损精细化分析、负荷预测等综合运行数据分析。
              </p>
            </div>
          </div>
          <div class="content last">
            <img src="../assets/imgs.png" alt="" />
            <div class="right_txt">
              <p class="title">一站式管家服务</p>
              <p class="txt">1、咨询方案，远景规划，可研方案；</p>
              <p class="txt">2、需求分析；模拟优化，运行策略。</p>
              <p class="txt">3、最优采购；安全建设；系统联调。</p>
              <p class="txt last">4、智能运行，检修服务，经济运营。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-foot></v-foot>
    <div class="toTop" v-if="btnFlag">
      <!-- 回顶部按钮为一张50*50的图片 -->
      <!-- btnFlag 控制图片显示隐藏 -->
      <!-- backTop 回顶部的方法 -->
      <img v-if="btnFlag" src="../assets/top.png" @click="backTop" />
    </div>
  </div>
</template>
<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import "videojs-flash";
import router from "../router/index";

export default {
  props: {
    title: {
      //模块标题
      type: String,
      default: ""
    }
  },
  data() {
    return {
      autoplay: true, //是否自动切换
      isPlay: false, //播放状态
      isIn: false, //鼠标是否位于播放器内
      cutTime: 5000, //轮播时间，单位毫秒
      nowIndex: 0,
      btnFlag: false,
      scrollTop: 0,
      index: 0,
      videos: [
        {
          src: require("../assets/banner1.mp4")
        },
        {
          src: require("../assets/banner2.mp4")
        },
        {
          src: require("../assets/banner3.mp4")
        }
      ]
    };
  },
  created() {
    let selectId = localStorage.getItem("toId");
    if (selectId) {
      //创建时执行跳转锚点位置
      this.$nextTick(() => {
        this.goAnchor(selectId);
        setTimeout(() => {
          localStorage.setItem("toId", "");
        }, 500);
      });
    }
  },
  methods: {
    delHandleMouseEnter() {
      this.$refs.carousel.handleMouseEnter = () => {};
    },
    goAnchor(selector) {
      document.querySelector(selector).scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest"
      });
    },
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop() {
      const that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop() {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 60) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    },
    handleChange(currentIndex, oldIndex) {
      // console.log(`当前索引:${currentIndex},原索引：${oldIndex}`);
      this.index = currentIndex;
    },
    gotoSuccess() {
      router.push("/success");
    },
    gotoInfor() {
      router.push("/information");
    },
    gotoInfor1() {
      router.push("/information1");
    },
    gotoInfor2() {
      router.push("/information2");
    },
    gotoMoreInfor() {
      router.push("/moreInfor");
    },
    gotoMoreInfor1() {
      router.push("/moreInfor8");
    },
    gotoMoreInfor2() {
      router.push("/moreInfor5");
    }
    // getlocal() {
    //   //找到锚点id
    //   let selectId = localStorage.getItem("toId");
    //   let toElement = document.getElementById(selectId);
    //   //如果对应id存在，就跳转
    //   if (selectId) {
    //     console.log(toElement,'toElement')
    //     toElement.scrollIntoView(true)
    //   }
    // },
  },
  // window对象，所有浏览器都支持window对象。它表示浏览器窗口，监听滚动事件
  mounted() {
    window.addEventListener("scroll", this.scrollToTop, true);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  }
};
</script>
<style>
.container {
  background: #f7f7f7;
  font-family: "Microsoft YaHei";
}
.header {
  position: absolute;
  display: flex;
  background-color: #000;
  z-index: 2;
  height: 75px;
  top: 0;
  width: 100%;
  font-family: SimHei;
}
.header img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.textGroup {
  display: flex;
  margin-left: auto;
}
.textGroup .text {
  display: flex;
  color: #fff;
  cursor: pointer;

  align-items: center;
  font-size: 24px;
  margin-right: 30px;
}
.textGroup .text1 {
  margin-right: 55px;
}
.textGroup .text2 {
  margin-right: 200px;
}
.show-imgs-container {
  width: 100%;
}
/* // 去除鼠标事件 */
video {
  pointer-events: none;
  width: 100%;
}
.el-carousel__container {
  width: 100%;
  object-fit: fill;
  height: 910px !important;
}
/* // 去除所有控件 */
video::-webkit-media-controls-enclosure {
  display: none;
}
/* 视频全屏 */
el-carousel-item {
  width: 100% !important;
  height: calc(100vh - 20px) !important;
  object-fit: fill;
}
/* 去掉视频中部的播放按钮 */
.video-js .vjs-big-play-button {
  opacity: 0;
}
.el-carousel__arrow {
  background-color: rgba(31, 45, 61, 0);
}
.el-icon-arrow-left {
  font-size: 20px;
  background-color: #666;
  border-radius: 50%;
  padding: 10px;
  margin-left: 10px;
}
.el-icon-arrow-right {
  font-size: 20px;
  background-color: #666;
  border-radius: 50%;
  padding: 10px;
  margin-left: -50px;
}
.el-carousel__button {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-right: 10px;
  margin-bottom: 30px;
}
.product,
.case,
.company {
  margin-top: 90px;
  text-align: center;
  color: #515151;
}
.case {
  background-color: #000;
  color: #fff;
  padding-top: 80px;
  padding-bottom: 200px;
}
.product_title,
.case_title,
.company_title {
  font-size: 52px;
  letter-spacing: 2px;
  font-family: SimHei;
}
.product_miniTitle,
.case_miniTitle,
.company_miniTitle {
  margin-top: 10px;
  font-size: 22px;
  letter-spacing: 2px;
  margin-bottom: 20px;
  font-size: "Microsoft YaHei";
}
.company_miniTitle {
  margin-bottom: 70px;
}
.proClass {
  display: flex;
  justify-content: center;
  margin-top: 70px;
}
.imgIcon {
  width: 80px;
  height: 80px;
}
.proTitle {
  font-size: 22px;
  margin-top: 10px;
}
.proText {
  font-size: 15px;
  margin-top: 5px;
  margin-bottom: 30px;
}
.pro1,
.pro2,
.pro3 {
  background-color: rgba(236, 235, 235, 0.2);
  border-radius: 5px;

  padding: 10px 20px;
  width: 280px;
  height: 260px;
  margin-right: 80px;
  /* 超出区域隐藏 */
  overflow: hidden;
  /* 超出指定区域显示滚动条 */
  overflow: auto;
}
.pro1:hover {
  background-color: #fff;
  box-shadow: 2px 2px 2px 2px rgba(243, 241, 241, 0.9);
}
.pro2:hover {
  background-color: #fff;
  box-shadow: 2px 2px 2px 2px rgba(243, 241, 241, 0.9);
}
.pro3:hover {
  background-color: #fff;

  box-shadow: 2px 2px 2px 2px rgba(243, 241, 241, 0.9);
}
.pro1 img {
  margin-top: 20px;
  margin-bottom: 15px;
}
.pro1 .intro {
  text-align: left;
  width: 35px;
  height: 35px;
  background: #f5a93e;
  margin: 0 auto;
}
.pro2 .intro {
  text-align: left;
  width: 35px;
  height: 35px;
  background: #f5a93e;
  margin: 0 auto;
}
.pro3 .intro {
  text-align: left;
  width: 35px;
  height: 35px;
  background: #f5a93e;
  margin: 0 auto;
}
.intro span {
  color: #fff;
  font-size: 20px;
  line-height: 35px;
  margin-left: 8px;
  cursor: pointer;
}
.pro1 .intro:hover {
  background-color: #fa9912;
}
.pro2 .intro:hover {
  background-color: #fa9912;
}
.pro3 .intro:hover {
  background-color: #fa9912;
}
.pro2 img {
  margin-top: 20px;
  margin-bottom: 15px;
}
.pro3 {
  margin-right: 0;
}
.pro3 img {
  margin-top: 20px;
  margin-bottom: 15px;
}
.one {
  display: flex;
  justify-content: center;
  margin-top: 80px;
}
.one .left {
  width: 170px;
  height: 170px;
}
.one .right {
  margin-left: 40px;
  text-align: left;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: left;
  width: 800px;
}
.right .title {
  font-size: 20px;
  margin-bottom: 20px;
}
.right .info {
  font-size: 15px;
  margin-bottom: 20px;
}
.right .arrow {
  background-color: #f5a93e;
  padding: 5px 0;
  color: #fff;
  width: 120px;
  height: 20px;
  font-size: 15px;
  text-align: center;
  line-height: 20px;
  border-radius: 5px;
  cursor: pointer;
}
.right .arrow:hover {
  background-color: #fa9912;
}
.btn_more {
  background-color: #f5a93e;
  width: 200px;
  font-size: 28px;
  padding: 10px 10px;
  border-radius: 8px;
  margin-top: 80px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
}
.btn_more:hover {
  background-color: #fa9912;
}
.toTop {
  position: fixed;
  bottom: 120px;
  right: 40px;
  width: 25px;
  height: 25px;
  cursor: pointer;
  background: rgb(172, 171, 171);
  border-radius: 50%;
  z-index: 99;
  padding: 12px;
}
.toTop img {
  width: 25px;
  height: 25px;
}
.company .big {
  background-color: #fff;
  width: 70%;
  margin: 0 auto;
  box-shadow: 2px 1px 2px 2px #eee;
  border-radius: 5px;
}
.big .content {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
}
.big img {
  width: 360px;
  height: 390px;
}
.big .right_txt {
  /* 文字位于图片的中心位置 */
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-left: 120px;
  width: 352px;
  height: 173px;
}
.big .right_txt .title {
  font-size: 23px;
  margin-bottom: 20px;
}
.big .right_txt .txt {
  font-size: 16px;
  padding-bottom: 6px;
   text-align: justify; /*实现两端对齐*/

}
.big .right_txt .last {
  padding-bottom: 0;
}
.small {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 70%;
  flex: 3;
  justify-content: space-between;
  margin-top: 30px;
}
.small .content {
  background-color: #fff;
  padding: 10px 20px;
  width: 380px;
  /* height: 390px; */
  /* 超出区域隐藏 */
  overflow: hidden;
  /* 超出指定区域显示滚动条 */
  overflow: auto;
  box-shadow: 2px 1px 2px 2px #eee;
  border-radius: 5px;
  margin-bottom: 80px;
}
.small .last {
  margin-right: 0;
}
.small .title {
  margin-top: 10px;
  font-size: 23px;
}
.small .txt {
  font-size: 14px;
  /* line-height: 20px; */
  margin-top: 10px;
  text-indent: 2em;
  text-align: left;
}
.vedio_wrap1 {
  /* font-size: 50px; */
  /* color: red; */
  position: absolute;
  top: 360px;
  z-index: 99;
  left: 240px;
}
.vedio_wrap1 .title1 {
  color: #ff9c0f;
  font-size: 26px;
}
.vedio_wrap1 .title2 {
  color: #fff;
  font-size: 26px;
}
.vedio_wrap1 .txt {
  color: #fff;
  font-size: 15px;
  margin-top: 30px;
}
.vedio_wrap1 .btn {
  color: #fff;
  background-color: #ff9c0f;
  font-size: 14px;
  padding: 15px 0;
  text-align: center;
  border-radius: 10px;
  margin-top: 30px;
  width: 120px;
  cursor: pointer;
}
.vedio_wrap2 {
  font-size: 50px;
  color: blue;
  position: absolute;
  top: 200px;
  z-index: 99;
}
.vedio_wrap3 {
  font-size: 50px;
  color: yellow;
  position: absolute;
  top: 200px;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue